import React from 'react'
import { Trail } from '../../types/Trail'
import { TrailCard } from './TrailCard'

export const TrailBlock = ({trail}:Props) => {
    return (
        <div className='col-span-1'>
            <div className='font-bold text-xl'>{trail.name}</div>
            <div className='grid grid-cols-3 gap-3'>
                {trail.modules.map(item => (
                    <div key={item.id}>
                        <TrailCard module={item} />
                    </div>
                            
                ))}
            </div>
        </div>
    )
}
interface Props{
    trail:Trail
}